import checkout from "./form";

const {
  formField: {
    firstName,
    lastName,
    email,
    workPhoneNumber,
    code,
    ssn,
    subCompany,
    location,
    job,
    rate,
    status,
    typeCode,
  },
} = checkout;

export default {
  [firstName.name]: "",
  [lastName.name]: "",
  [email.name]: "",
  [code.name]: "9XXXXX",
  [location.name]: "",
  [subCompany.name]: "",
  [job.name]: "",
  [rate.name]: "",
  [ssn.name]: "",
  [workPhoneNumber.name]: "",
  [status.name]: "A",
  [typeCode.name]: "",
};
